export const SD_SET_DETAILS = 'SET_DETAILS'
export const SD_SET_RESULTS = 'SET_RESULTS'
export const SD_SET_ORDERING = 'SET_ORDERING'
export const SD_SET_STATUS = 'SET_STATUS'
export const SD_EDIT = 'EDIT'
export const SD_ADD = 'ADD'
export const SD_DELETE = 'DELETE'
